import { httpClient } from "./httpClient";

export interface DashboardStats {
  totalUsers: number;
  totalTeams: number;
  totalCompanies: number;
  totalWorkShifts: number;
  pendingDutyRequests: number;
  pendingInquiries: number;
  activeAttendanceToday: number;
  totalDutiesThisMonth: number;
  todaysStats: {
    newUsers: number;
    newDutyRequests: number;
    resolvedInquiries: number;
  };
}

export const getDashboardStats = async (): Promise<DashboardStats> => {
  const response = await httpClient.get("/dashboard/stats");
  return response.data;
};
